// Angular
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

// Services
import { AnalyticsFacade } from '@amfam/shared/analytics';
import { BillingAnalytics } from '@amfam/shared/models';
import { DsModalService } from '@amfam/ui-kit';

@Component({
  selector: 'ds-bill-account-payments-scheduled-modal',
  templateUrl: './bill-account-payments-scheduled-modal.component.html',
  standalone: false
})
export class BillAccountPaymentsScheduledModalComponent implements OnInit, OnChanges {
  public static readonly billAccountPaymentsScheduledModalID = 'BillAccountPaymentsScheduled';

  @Output()
  public understandEvent = new EventEmitter<boolean>();

  @Output()
  public closeEvent = new EventEmitter<boolean>();

  billAccountPaymentsScheduledModal: string;
  sendAnalytic = true;

  // Shared subject for completing observables
  private _visible = false;

  constructor(
    private modalService: DsModalService,
    private analyticsFacade: AnalyticsFacade
  ) {}

  get visible(): boolean {
    return this._visible;
  }

  @Input()
  set visible(value: boolean) {
    this._visible = value;
  }

  ngOnInit() {
    this.billAccountPaymentsScheduledModal = this.modalService.createModalId(
      BillAccountPaymentsScheduledModalComponent.billAccountPaymentsScheduledModalID
    );
  }

  ngOnChanges(): void {
    if (this.visible) {
      this.open();
    } else {
      this.close();
    }
  }

  open(): void {
    this.modalService.open(this.billAccountPaymentsScheduledModal);
  }

  close(): void {
    this.modalService.close(this.billAccountPaymentsScheduledModal);
    this.closeEvent.emit();
  }

  cancel(): void {
    this.analyticsFacade.trackButtonClick(BillingAnalytics.clickPastDueModalCancelLink);
    this.close();
  }

  understand(): void {
    this.analyticsFacade.trackButtonClick(BillingAnalytics.clickPastDueModalConfirmLink);
    this.modalService.close(this.billAccountPaymentsScheduledModal);
    this.understandEvent.emit();
  }
}
